import React from 'react';

const EyeIcon = props => (<svg viewBox="0 0 22 22" width="22px" height="22px" {...props}>
  <path d="M17.667 9.479C16.77 8.58 15.725 7.873 14.563 7.38c-2.41-1.022-5.195-1.022-7.605 0 C5.796 7.872 4.751 8.579 3.854 9.479c-0.897 0.899-1.601 1.947-2.093 3.115l1.806 0.767c0.393-0.932 0.956-1.769 1.674-2.49 c0.717-0.72 1.553-1.285 2.482-1.678c1.925-0.817 4.154-0.816 6.076 0c0.929 0.394 1.766 0.959 2.481 1.678 c0.718 0.72 1.281 1.559 1.673 2.49l1.809-0.767C19.269 11.426 18.565 10.379 17.667 9.479z" />
  <path d="M10.76 10.583c-1.317 0-2.385 1.073-2.385 2.393c0 1.321 1.068 2.394 2.385 2.394 c1.318 0 2.386-1.072 2.386-2.394C13.146 11.656 12.078 10.583 10.76 10.583z" />
</svg>);

export default EyeIcon;
